import React, { FC } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useQueryClient } from 'react-query';

import { useUpdateUserProfileMutation } from 'api';
import { useBootstrapQueryKey, useCapabilities, useCurrentUser } from 'hooks';
import { PRE_SELF_SERVE_USER_CREATED_AT_TIME } from 'app-constants';
import { hasCapability } from 'helpers';
import * as paths from 'paths';

import SetupButton from './SetupButton';

const SetupProfileButton: FC = () => {
  const currentUser = useCurrentUser();
  const history = useHistory();
  const queryClient = useQueryClient();
  const capabilities = useCapabilities();
  const { t } = useTranslation();
  const bootstrapQueryKey = useBootstrapQueryKey();

  const isPreSelfServe = currentUser.created_at < PRE_SELF_SERVE_USER_CREATED_AT_TIME;
  const isOwner = hasCapability(capabilities, 'Service.Client.Generic.RoleBased.Owner');

  const { mutate } = useUpdateUserProfileMutation({
    onSettled: () => {
      void queryClient.refetchQueries(bootstrapQueryKey);
    },
  });

  function handleClose() {
    mutate({ data: { id: currentUser.id, setup_completed: true } });
  }

  if (currentUser.setup_completed || isPreSelfServe || isOwner) {
    return null;
  }

  return (
    <SetupButton
      label={t('setup:setupProfile')}
      onClick={() => history.push(paths.setupProfile)}
      onClose={handleClose}
    />
  );
};

export default SetupProfileButton;
